import BansheeSmartList from './src/SmartList'

BansheeSmartList.install = function (Vue) {
  Vue.component(BansheeSmartList.name, BansheeSmartList)
}

export default BansheeSmartList
